import { AWFAction } from '@ansys-internal/awf-angular/contributions';
import { ActionsEnum } from '../../shared/enums';

export class UpdateInputs implements AWFAction<null, void> {
  public readonly type = ActionsEnum.UPDATE_INPUTS;
  execute: () => Promise<void> = async () => {
    return;
  };
}
